<template>
  <div class="wrapper">
    <transition name="fade">
      <div class="overlay">
        <div class="spinner-container">
          <div class="spinner" />
          <img class="logo" src="@/assets/1home-360.svg" />
        </div>
        <span v-if="$props.text" class="text">{{ $props.text }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeLoadings: []
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../common/_variables.scss";
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  z-index: 1000;
  .text {
    font-size: 0.9rem;
    font-weight: bold;
    margin-top: 20px;
    padding: 0 15px;
  }
}
</style>
